import React from 'react';
import { Text, StyleSheet, View } from '@react-pdf/renderer';
import dayjs from 'dayjs';
interface PdfCoverLetterFooterProps {
  data: any;
}

export const PdfCoverLetterFooter: React.FC<PdfCoverLetterFooterProps> = (props) => {
  const styles = StyleSheet.create({
    text: {
      fontSize: '8px'
    }, 
    footerText: {
      fontSize: 6, color: 'gray', paddingBottom: 2
    }
  });

  const revisionDate = dayjs().format('MMMM YYYY');


  return (
    
      <View >
      {props.data.entityId && <Text style={[styles.text, { textAlign: 'center', marginTop: 3 }]}>Entity ID: {props.data.entityId}</Text>}
      <View style={{ flexDirection: 'row', justifyContent: 'space-between', marginTop: 10 }}>
        <View>
          <Text style={styles.footerText}>ECFMG® Credential Verification Form</Text>
          <Text style={styles.footerText}>Copyright © 2025 by Intealth. All rights reserved.</Text>
        </View>

        <View style={{ alignItems: 'flex-end' }}>
          <Text style={styles.footerText}>Rev. {revisionDate}</Text> 
          <Text
            style={styles.footerText}
            render={({ pageNumber, totalPages }) => `Page ${pageNumber} of ${totalPages}`}
          />
        </View>
      </View>
      </View>

  );
};

export default PdfCoverLetterFooter;
